<script>
export default {
  props: {
    stageList: {
      type: Array,
      default: () => []
    },
    // 当前阶段的索引,从0开始
    currentStage: {
      type: Number,
      default: -1
    }
  }
}
</script>

<template>
  <div class="stage_list">
    <div
      v-for="(item, index) in stageList"
      :key="index"
      :class="{
        first_stage: index === 0,
        completed_stage: index < currentStage,
        current_stage: index === currentStage,
        last_stage: stageList.length - 1 === index
      }"
      class="stage_item"
    >
      <div class="stage_ui_container">
        <div class="stage_line before_dot"></div>
        <div class="stage_dot"></div>
        <div class="stage_line after_dot"></div>
      </div>
      <div
        :class="{
          green: index <= currentStage
        }"
        class="stage_title"
      >
        {{ item.stageName }}
      </div>
    </div>
  </div>
</template>
<style lang="scss">
.stage_list {
  display: flex;
  .stage_item {
    flex-grow: 2;
    .stage_ui_container {
      display: flex;
      align-items: center;
    }
    .stage_line {
      height: 2px;
      background: rgba(192, 204, 218, 1);
      flex-grow: 1;
    }
    .stage_dot {
      border: 2px solid rgba(192, 204, 218, 1);
      border-radius: 50%;
      width: 10px;
      height: 10px;
    }
    .stage_title {
      margin-top: 15px;
      text-align: center;
      color: rgba(192, 204, 218, 1);
      font-size: 16px;
      @media screen and (max-width: 940px) {
        margin-top: 10px;
        font-size: 12px;
      }
    }
  }
  .first_stage {
    flex-grow: 1;
    .before_dot {
      position: absolute;
    }

    .stage_title {
      text-align: left;
    }
  }

  .last_stage {
    flex-grow: 1;

    .after_dot {
      position: absolute;
    }
    .stage_title {
      text-align: right;
    }
  }

  .completed_stage {
    .stage_line {
      background: rgba(33, 222, 140, 1);
    }
    .stage_dot {
      border: rgba(33, 222, 140, 1);
      background: rgba(33, 222, 140, 1);
    }
    .stage_title {
      color: rgba(33, 222, 140, 1);
    }
  }
  .current_stage {
    .before_dot {
      background: rgba(33, 222, 140, 1);
    }
    .stage_dot {
      border: rgba(33, 222, 140, 1);
      background: rgba(33, 222, 140, 1);
    }
    .stage_title {
      color: rgba(33, 222, 140, 1);
    }
  }
}
</style>
